import script from "./CartButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CartButton.vue?vue&type=script&setup=true&lang=js"

import "./CartButton.vue?vue&type=style&index=0&id=6e434515&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e434515"]])

export default __exports__